import { RouteLocationRaw } from "vue-router"
import { useAcl } from "vue-simple-acl"

/** Applies the same account availability rule used by account-specific UI such as DevOps teams. */
export default function showElementByAccount(
  _to,
  _from,
  next: (arg?: RouteLocationRaw) => void
): void {
  if (useAcl().can("showElementByAccount")) {
    next()
    return
  }

  next({
    name: "Error",
    query: { code: 403 }
  })
}
